import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/lib/format";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  return (
    <div
      data-testid={`product-card-${product.handle}`}
      className="group bg-white rounded-3xl p-6 flex flex-col gap-5 shadow-[0_4px_24px_rgba(111,80,58,0.05)] transition-transform duration-300 hover:-translate-y-1"
    >
      <Link to={`/product/${product.handle}`} className="block">
        <div className="relative aspect-square rounded-2xl bg-[#F8F5EF] overflow-hidden">
          {product.compareAt && (
            <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full bg-[#B8C4A3] text-white text-xs font-semibold">
              Save {formatPrice(product.compareAt - product.price)}
            </span>
          )}
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
      </Link>
      <div className="flex flex-col gap-1">
        <span className="text-xs font-semibold uppercase tracking-[0.12em] text-[#B8C4A3]">{product.badge}</span>
        <Link to={`/product/${product.handle}`}>
          <h3 className="font-heading text-lg font-semibold text-[#6F503A] leading-snug">{product.name}</h3>
        </Link>
        <p className="text-sm text-[#6F503A]/60">{product.subtitle}</p>
      </div>
      <div className="mt-auto flex items-center justify-between gap-3">
        <div className="flex items-baseline gap-2">
          <span className="font-heading text-xl font-semibold text-[#6F503A]">{formatPrice(product.price)}</span>
          {product.compareAt && (
            <span className="text-sm text-[#6F503A]/40 line-through">{formatPrice(product.compareAt)}</span>
          )}
        </div>
        <button
          data-testid={`add-to-cart-${product.handle}`}
          onClick={() => addItem(product, { qty: 1, sellingPlan: "onetime" })}
          className="px-5 py-2.5 rounded-full bg-[#6F503A] text-[#F8F5EF] text-sm font-medium hover:bg-[#5b4130] transition-colors"
        >
          Add
        </button>
      </div>
    </div>
  );
};
